import React, { useState } from "react";
import { Button, Flex } from "_styleguide";
import { useSettings } from "_contexts/useSettings";
import { useLead } from "_contexts/useLead";
import { message } from "@centrate-io/barn";
import { useNavigate } from "react-router-dom";
import { isDarkColor } from "_helpers/colors";
import { useStats } from "_contexts/useStats";
import { useGTM } from "_hooks/useGTM";
import "./Footer.scss";

function Footer(props) {
  const navigate = useNavigate();
  const { settings, isPreview } = useSettings();
  const { saveLead } = useLead();
  const { updateStats, visitorId } = useStats();
  const { gtmFormSubmit, gtmError } = useGTM();
  const [saving, setSaving] = useState(false);

  const saveForm = async () => {
    if (isPreview) {
      if (props.next) navigate(`/${props.next}`);
      return;
    }
    setSaving(true);
    try {
      // Get recaptcha token if the getter function is provided
      let recaptchaToken = null;
      if (props.getRecaptchaToken) {
        recaptchaToken = await props.getRecaptchaToken();
      }

      const leadId = await saveLead({}, recaptchaToken);
      if (leadId) {
        localStorage.setItem("pp_lead", leadId);
      } else {
        throw new Error();
      }
      if (props?.settings?.name) {
        await updateStats({
          application_id: leadId,
          visitor_id: visitorId, // Include visitor_id for linking
          self_enrollment_id: settings.id,
          page: props?.settings?.name,
          drop_off_page: props?.next || props?.settings?.name,
          link_visitor_to_application: leadId && visitorId ? true : false, // Link only if we have both leadId and visitorId
        });
      }
      gtmFormSubmit(props?.settings?.name || "unknown_step", {
        step: props?.settings?.name,
        next_step: props.next,
      });
      if (props.next) navigate(`/${props.next}`);
    } catch (err) {
      gtmError("save_application_failed", {
        step: props?.settings?.name,
      });
      message.error("Error saving application, try again");
    }
    setSaving(false);
  };

  const primaryColor = settings?.primary_color || "#0f766e";

  return (
    <Flex id="footer" align="center">
      <Button
        block
        size="large"
        style={{
          background: primaryColor,
          color: isDarkColor(primaryColor) ? "#fff" : "#000",
        }}
        onClick={saveForm}
        loading={saving}
        disabled={props.disableNext}
      >
        Next
      </Button>
    </Flex>
  );
}

export default Footer;
